export class AddCardRequest {
  account_id: string;

  constructor(account_id: string) {
    this.account_id = account_id;
  }
}
